<template>
  <div class="game-container">
    <div id="game-container"><canvas id="gameCanvas"></canvas></div>
  </div>
</template>

<script>
import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixinV2';
import createjsMixin from '../../mixins/createjsMixinV2';
export default {
  name: 'mp-connect-v2',
  mixins: [defaultMixins, createjsMixin],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
      moved: 0,
      ticker: false,
      animation: false,
      movesTo: [],
      targets: [],
      corrects: [],
      clones: [],
      maxClone: 0,
    };
  },
  beforeMount() {
    this.prototypeArray();
  },
  mounted() {
    this.ticker = createjs.Ticker;
    this.setDataGame();
    this.initGame();
    createjs.Touch.enable(this.stage);
    // // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    stageMouseDown(e) {
      if (!this.mousedown) {
        this.resetCheckStatus();
        var grx = -1;
        var ix = -1;
        this.images.forEach(function (gr, i) {
          gr.forEach(function (cont, j) {
            if (e.target.id == cont.id) {
              ix = j;
              grx = i;
            }
          });
        });
        if (ix >= 0 && grx >= 0 && !this.images[grx][ix].block) {
          this.stage.on('stagemousemove', this.stageMouseMove);
          this.images[grx][ix].point.visible = true;
          this.images[grx][ix].point.cache(
            -this.images[grx][ix].point.rad,
            -this.images[grx][ix].point.rad,
            this.images[grx][ix].point.rad * 2,
            this.images[grx][ix].point.rad * 2
          );
          this.point.x = e.stageX - this.offset.x;
          this.point.y = e.stageY - this.offset.y;
          this.point.visible = true;
          this.point.cache(-this.point.rad, -this.point.rad, this.point.rad * 2, this.point.rad * 2);
          this.point.start = { gr: grx, i: ix };
          this.mousedown = true;
        }
      }
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        var pos = {
          x: e.stageX - this.offset.x,
          y: e.stageY - this.offset.y,
        };
        this.line.graphics
          .clear()
          .s(
            this.initData.line && this.initData.line.connect !== undefined
              ? this.initData.line.connect
              : 'rgb(128, 128, 128)'
          )
          .ss(this.initData.line && Number.isInteger(this.initData.line.size) ? this.initData.line.size : 2, 'round')
          .mt(
            this.images[this.point.start.gr][this.point.start.i].point.x,
            this.images[this.point.start.gr][this.point.start.i].point.y
          )
          .lt(pos.x, pos.y);
        this.line.cache(-this.offset.x, -this.offset.y, this.width, this.height);
        this.point.x = pos.x;
        this.point.y = pos.y;
      }
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        this.point.visible = false;
        this.line.graphics.clear();
        this.line.uncache();
        var self = this;
        var ix = -1,
          grx = -1;
        this.stage.getObjectsUnderPoint(self.point.x, self.point.y).forEach(function (bmp) {
          self.images.forEach(function (gr, i) {
            gr.forEach(function (indx, j) {
              if (indx.id == bmp.id) {
                ix = j;
                grx = i;
              }
            });
          });
        });
        if (
          ix >= 0 &&
          grx != this.point.start.gr &&
          !this.images[grx][ix].block &&
          !this.images[this.point.start.gr][this.point.start.i].block
        ) {
          var draw = -1;
          this.images[this.point.start.gr][this.point.start.i].point.visible = true;
          this.images[grx][ix].point.visible = true;
          this.images[this.point.start.gr][this.point.start.i].point.cache(
            -this.images[this.point.start.gr][this.point.start.i].point.rad,
            -this.images[this.point.start.gr][this.point.start.i].point.rad,
            this.images[this.point.start.gr][this.point.start.i].point.rad * 2,
            this.images[this.point.start.gr][this.point.start.i].point.rad * 2
          );
          this.images[grx][ix].point.cache(
            -this.images[grx][ix].point.rad,
            -this.images[grx][ix].point.rad,
            this.images[grx][ix].point.rad * 2,
            this.images[grx][ix].point.rad * 2
          );
          this.lines.forEach(function (item, j) {
            if (item.points.indexOf({ i: ix, gr: grx }) != -1 && item.points.indexOf(self.point.start) != -1) draw = j;
          });
          var line = {};
          if (draw == -1) line.shape = new createjs.Shape();
          else line = this.lines[draw];
          line.shape.graphics
            .clear()
            .s(this.initData.line && this.initData.line.select !== undefined ? this.initData.line.select : 'black')
            .ss(this.initData.line && Number.isInteger(this.initData.line.size) ? this.initData.line.size : 2, 'round')
            .mt(this.images[grx][ix].point.x, this.images[grx][ix].point.y)
            .lt(
              this.images[this.point.start.gr][this.point.start.i].point.x,
              this.images[this.point.start.gr][this.point.start.i].point.y
            );
          line.shape.on('click', this.handleClickLine);
          line.points = [{ i: ix, gr: grx }, this.point.start];
          line.block = false;
          line.status = 0;
          this.lines.push(line);
          if (draw == -1) {
            if (this.initData.hideLine)
              this.stage.addChildAt(line.shape, this.stage.getChildIndex(this.stage.getChildByName('canvas')) + 1);
            else this.stage.addChildAt(line.shape, this.stage.children.length);
          }
        } else {
          var count = 0;
          this.lines.forEach(function (line) {
            if (
              (line.points[0].gr == self.point.start.gr && line.points[0].i == self.point.start.i) ||
              (line.points[1].gr == self.point.start.gr && line.points[1].i == self.point.start.i)
            ) {
              count++;
            }
          });
          this.images[this.point.start.gr][this.point.start.i].point.visible = count > 0;
        }
      }
      this.stage.removeAllEventListeners('stagemousemove');
    },
    handleClickLine(e) {
      this.resetCheckStatus();
      this.removeLine(e.currentTarget);
    },
    removeLine(cLine) {
      var ix = -1;
      this.lines.forEach(function (line, i) {
        if (line.shape == cLine) ix = i;
      });
      if (!this.lines[ix].block) {
        this.lines.splice(ix, 1);
        var self = this;
        this.images.forEach(function (gr, i) {
          gr.forEach(function (bmp, j) {
            if (bmp.point.visible) {
              var count = 0;
              self.lines.forEach(function (line) {
                if (
                  (line.points[0].i == j && line.points[0].gr == i) ||
                  (line.points[1].i == j && line.points[1].gr == i)
                )
                  count++;
              });
              bmp.point.visible = count > 0;
            }
          });
        });
        this.stage.removeChild(cLine);
      }
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      // console.log('CHECK');
      var isCorrect = true;
      var self = this;
      this.lines.forEach(function (line) {
        if (self.initData.corrBlock === true && line.status === 2) line.block = true;
        else {
          if (self.initData.corrBlock !== true || (self.initData.corrBlock === true && line.status !== 2)) {
            line.status = 0;
          }
          line.block = false;
        }
      });
      this.images.forEach(function (gr, i) {
        gr.forEach(function (bmp, j) {
          bmp.lines = 0;
          bmp.block = false;
        });
      });
      this.images.forEach(function (gr, i) {
        gr.forEach(function (bmp, j) {
          if (!bmp.point.visible && bmp.correct.length > 0) {
            isCorrect = false;
          } else if (bmp.point.visible) {
            var count = [];
            var cor = Array.isArray(bmp.correct) ? bmp.correct.length : 0;
            self.lines.forEach(function (line, cL) {
              // start linii lub koniec linii jest na tym obrazku
              if (
                (line.points[0].gr == i && line.points[0].i == j) ||
                (line.points[1].gr == i && line.points[1].i == j)
              ) {
                count.push(cL);
              }
            });
            // jeżeli z obrazka wychodzi tyle linii ile powinno
            if (count.length == cor && cor > 0) {
              var c = 0;
              for (let k = 0; k < count.length; k++) {
                let line = self.lines[count[k]];
                for (let l = 0; l < bmp.correct.length; l++) {
                  if (
                    (line.points[0].gr == i &&
                      line.points[0].i == j &&
                      line.points[1].gr == bmp.correct[l].gr &&
                      line.points[1].i == bmp.correct[l].i) ||
                    (line.points[1].gr == i &&
                      line.points[1].i == j &&
                      line.points[0].gr == bmp.correct[l].gr &&
                      line.points[0].i == bmp.correct[l].i)
                  )
                    c++;
                }
              }
              if (c != count.length) {
                cor = 0;
                bmp.block = false;
              } else {
                // jeżeli linie wychodzące są prawdiłowe
                for (let k = 0; k < count.length; k++) {
                  let line = self.lines[count[k]];
                  if (self.initData.corrBlock === true) {
                    line.block = true;
                    bmp.block = true;
                    line.status = 2;
                  } else if (line.status == 0) line.status = 2;
                }
              }
            }
            // jeżeli z obrazka wychodzi za dużo/za mało linii
            if (count.length !== cor) {
              for (let k = 0; k < count.length; k++) {
                let line = self.lines[count[k]];
                if (!line.block) line.status = 1;
              }
              isCorrect = false;
            }
          }
        });
      });
      if (this.initData.removeInCorrects === true) {
        var flg = false;
        while (!flg) {
          var del = false;
          this.lines.forEach(function (line) {
            if (line.status == 1) {
              self.removeLine(line.shape);
              del = true;
            }
          });
          flg = !del;
        }
      }
      this.lines.forEach(function (line) {
        if (line.status == 2) {
          line.shape.graphics
            .clear()
            .s(self.initData.line && self.initData.line.good !== undefined ? self.initData.line.good : 'green')
            .ss(self.initData.line && Number.isInteger(self.initData.line.size) ? self.initData.line.size : 2, 'round')
            .mt(
              self.images[line.points[0].gr][line.points[0].i].point.x,
              self.images[line.points[0].gr][line.points[0].i].point.y
            )
            .lt(
              self.images[line.points[1].gr][line.points[1].i].point.x,
              self.images[line.points[1].gr][line.points[1].i].point.y
            );
        } else {
          line.shape.graphics
            .clear()
            .s(self.initData.line && self.initData.line.bad !== undefined ? self.initData.line.bad : 'red')
            .ss(self.initData.line && Number.isInteger(self.initData.line.size) ? self.initData.line.size : 2, 'round')
            .mt(
              self.images[line.points[0].gr][line.points[0].i].point.x,
              self.images[line.points[0].gr][line.points[0].i].point.y
            )
            .lt(
              self.images[line.points[1].gr][line.points[1].i].point.x,
              self.images[line.points[1].gr][line.points[1].i].point.y
            );
        }
      });
      return isCorrect;
    },
    tick(e) {
      this.stage.update(e);
    },
  },
  beforeDestroy() {
    this.beforeDestroy();
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
}
</style>
